import styled from 'styled-components';
import { Icon } from 'react-icons-kit';
import { Button } from 'react-bootstrap';

export const ContainerWrapper = styled.div`
    padding-bottom: 20px;
    
    .panel-body {
        position: relative;
    }

    .loader {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        //width: 98%;
        //height: 87%;
        // background-color: #eceaea;
        background-image: url('/images/ajax-loader.gif');
        background-size: 50px;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 10000000;
        // opacity: 0.45;
        // border: 1px solid red;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        // background-color: #eee;
        // opacity: 0.5;
    }

    .loader > .message {
        z-index: 10000001;
        padding-top: 75px;
        font-weight: bold;
        color: black;
        font-size: 16px;
        // opacity: 1;
    }

    .section-notifications > .title-container {
        border-bottom: 1px solid #ddd;
        border-bottom-color: var(--orange);
        cursor: default;
    }

    .section-notifications > .title-container > .title {
        text-align: center;
        margin-bottom: -1px;
        background-color: var(--orange);
        border: 1px solid var(--orange);
        border-bottom-color: #fff;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 300px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .section-notifications > .title-container > .title.admin-title {
        width: 19.2%;
    }

    .section-notifications > .title-container > .title > h4 {
        // color: var(--orange);
        color: white;
        font-weight: 700;
        margin: 0
    }

    .section-notifications > .content {
        position: relative;
        padding: 10px;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: var(--orange);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .section-notifications > .content.collapsed:after {
        content: 'Click the tab above to expand...'
    }
    
    .section-urgent > .title-container {
        cursor: default;
        display: flex;
    }

    .section-urgent > .title-container > .title {
        margin-bottom: -1px;
        text-align: center;
        border: 1px solid var(--red);
        background-color: var(--red);
        border-bottom-color: #fff;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 20%;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .liverregistry & {
        .section-urgent > .title-container > .title {
            background-image: url(/images/nlr-background.png);
            border: 1px solid var(--orange);
        }

        .section-urgent > .content {
            border: 1px solid var(--orange);
        }
    }

    .section-urgent > .title-container > .title > h4 {
        margin: 0px;
        color: white;
        font-weight: 700;
    }

    .section-compliance > .title-container > .title.admin-title,
    .section-other > .title-container > .title.admin-title {
        min-width: 300px;
    }

    .section-urgent > .content {
        position: relative;
        padding: 10px;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: var(--red);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .section-urgent > .content.collapsed:after {
        content: 'Click the tab above to expand...'
    }

    .section-compliance > .title-container,
    .section-other > .title-container,
    .section-non-urgent > .title-container {
        cursor: default;
        display: flex;
    }

    .section-urgent,
    .section-other,
    .section-compliance {
         display: flex;
         flex-direction: column;
         flex: 1 0;
         min-height: 250px;
    }

    .section-other > .title-container > .title,
    .section-compliance > .title-container > .title {
        text-align: center;
        border: 1px solid cadetblue;
        border-bottom-color: #fff;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 20%;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .section-compliance > .title-container > .title > h4,
    .section-other > .title-container > .title > h4,
    .section-non-urgent > .title-container > .title > h4 {
        margin: 0px;
    }

    .section-compliance > .content,
    .section-other > .content,
    .section-non-urgent > .content {
        position: relative;
        padding: 10px;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: cadetblue;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .section-compliance > .content.collapsed:after,
    .section-other > .content.collapsed:after,
    .section-non-urgent > .content.collapsed:after {
        content: 'Click the tab above to expand...'
    }

    .notification-table {
        & > thead > tr > th,
        & > tbody > tr > td {
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
`;

export const IconWrapper = styled(Icon)`
    vertical-align: middle;

    & > svg {
        display: inline !important;
        vertical-align: baseline !important;
    }
`;

export const ButtonWrapper = styled(Button)`
    :focus, :active {
        outline: none !important;
        box-shadow: none;
    }
`;
